import { application } from "./application"

import FormController from "./form_controller"
application.register("form", FormController)
